import React from 'react'
import './LeftContent.css'
import Image from '../Image/Image'
import Info from '../Info/Info'

const LeftContent = () => {
  return (
    <div className='left-content'>
      <Image />
      <Info />
    </div>
  )
}

export default LeftContent
